'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module4Res3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4Res3, _Component);

  function Module4Res3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4Res3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4Res3.__proto__ || (0, _getPrototypeOf2.default)(Module4Res3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 3',
      title: 'Useful links',
      links: [{
        website: 'http://www.goodforkids.nsw.gov.au',
        tagline: 'Good for Kids Good for Life',
        description: ''
      }, {
        website: 'https://www.healthykids.nsw.gov.au',
        tagline: 'NSW Government Healthy Kids Program',
        description: 'This website contains background information and fact sheets ' + 'about healthy eating and physical activity for children, and activities on nutrition ' + 'and physical activity in schools.'
      }, {
        website: 'https://www.healthy-kids.com.au',
        tagline: 'The Healthy Kids SCA Website',
        description: 'This contains information, fact sheets and nutrition snippets ' + 'on a range of topics relevant to schools, canteens, and students.'
      }, {
        website: 'http://www.health.gov.au/internet/main/publishing.nsf/content/health-pubhlth-strateg-phys-act-guidelines',
        tagline: 'Federal Government Physical Activity and Sedentary Behaviour Guidelines for Children',
        description: ''
      }, {
        website: 'http://healthywa.wa.gov.au/Articles/F_I/Go-for-2-and-5',
        tagline: 'Australian Government, Department of Health and Ageing Go for 2 and 5 Campaign',
        description: 'Has a fruit and vegetable guide, lots of tasty recipes and fun activities for kids.'
      }, {
        website: 'https://www.betterhealth.vic.gov.au',
        tagline: 'Victorian Government Better Health Website',
        description: ''
      }, {
        website: 'https://www.betterhealth.vic.gov.au',
        tagline: 'The Fresh for Kids Program',
        description: 'Sydney Market\'s website for kids on fruit and vegetables. ' + 'Contains fruit and vegetable guides, resources for teachers and parents ' + 'and fun games, jokes and activities for kids.'
      }, {
        website: 'https://www.daa.asn.au',
        tagline: 'The Dietetics Association of Australia',
        description: ''
      }, {
        website: 'https://www.raisingchildren.net.au',
        tagline: 'Raising Children Network: Australian Parenting Website',
        description: ''
      }, {
        website: 'https://www.cancercouncil.com.au/cancer-prevention/diet-exercise/eat-it-to-beat-it/recipes-healthy-family-meals',
        tagline: 'Cancer Council New South Wales Eat-It-To-Beat-It Program',
        description: ''
      }]
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module4Res3, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                this.state.module
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, xs: 12, sm: 12 },
                _react2.default.createElement(
                  'p',
                  null,
                  'Here are some websites that you might be interested in that provide useful information about children\'s health, including healthy dietary habits.'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  this.state.links.map(function (item) {
                    return _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                          'a',
                          { target: '_blank', href: item.website },
                          item.tagline
                        ),
                        _react2.default.createElement(
                          'p',
                          null,
                          item.description
                        )
                      )
                    );
                  })
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module4Res3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module4Res3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/4/Res3.js
// module id = 1257
// module chunks = 0